// Copyright 2026, University of Maryland, All Rights Reserved
/**
 * Register legislative-review renderer components.
 */
import { registerRendererComponent } from '@/app-shell/renderer-components'
import {
  BillFindingsRenderer,
  BillReviewRenderer,
  BillCostEstimateRenderer,
  BillDepartmentRoutingRenderer,
} from './BillRenderers'

registerRendererComponent({
  id: 'bill-findings',
  label: 'Bill Findings',
  group: 'Legislative Review',
  versionMode: 'single',
  slots: [
    {
      key: 'findings',
      type: 'dataset',
      required: true,
      label: 'Findings',
      description: 'Risk-scored findings produced by the bill analysis pipeline.',
    },
  ],
  Component: BillFindingsRenderer,
})

registerRendererComponent({
  id: 'bill-review',
  label: 'Bill Review',
  group: 'Legislative Review',
  versionMode: 'single',
  slots: [
    {
      key: 'review',
      type: 'dataset',
      required: true,
      label: 'Review',
      description: 'Narrative review of the bill produced by the review pipeline.',
    },
  ],
  Component: BillReviewRenderer,
})

registerRendererComponent({
  id: 'bill-cost-estimate',
  label: 'Bill Cost Estimate',
  group: 'Legislative Review',
  versionMode: 'single',
  slots: [
    {
      key: 'costs',
      type: 'dataset',
      required: true,
      label: 'Cost Estimate',
      description: 'Fiscal-impact estimate produced by the cost-estimate pipeline.',
    },
  ],
  Component: BillCostEstimateRenderer,
})

registerRendererComponent({
  id: 'bill-department-routing',
  label: 'Bill Department Routing',
  group: 'Legislative Review',
  versionMode: 'single',
  slots: [
    {
      key: 'routing',
      type: 'dataset',
      required: true,
      label: 'Department Routing',
      description: 'Recommended owning department(s) for the bill.',
    },
  ],
  Component: BillDepartmentRoutingRenderer,
})
